import React from 'react'
import { TemplateObject } from '../../Models/TemplateObject'

type Props = {
    inputProps: TemplateObject
    changeHandler?: React.ChangeEventHandler<HTMLInputElement>
}

const InputType = ({ inputProps, changeHandler }: Props) => {
    return (
        <>
            {' '}
            {inputProps?.showLabel && (
                <label className="form-label">
                    {inputProps.text}
                </label>
            )}
            <input
                id={inputProps.id}
                type={inputProps.type}
                name={inputProps.name}
                className={inputProps.className}
                style={inputProps.style}
                placeholder={inputProps.placeholder}
                onChange={changeHandler}
            />
        </>
    )
}

export default InputType
